import { useKeycloak } from '@react-keycloak/web';
import { updateAuth } from 'app/store/reducers/app/authentication';
import { useAppDispatch } from 'app/store/store';
import { useEffect, useState } from 'react';

export const useKeycloakAuth = () => {
  const { keycloak, initialized } = useKeycloak();
  const dispatch = useAppDispatch();
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    if (!initialized) {
      // still initializing
      return;
    }

    if (!keycloak.authenticated) {
      keycloak.login({ redirectUri: window.location.href }).catch(err => {
        console.error('[Auth] Keycloak login error:', err);
        setError(err);
      });
      return;
    }

    // Authenticated
    try {
      dispatch(updateAuth({ account: getKeycloakAccount(keycloak) }));
    } catch (e) {
      console.error('[Auth] Failed to parse account from token:', e);
      setError(e);
    }
  }, [initialized, keycloak.authenticated, keycloak, dispatch]);
  return {
    initialized,
    isAuthenticated: keycloak.authenticated,
    error, // surface for UI if desired
  };
};

const getKeycloakAccount = keycloak => {
  const tokenParsed = keycloak.tokenParsed ?? {};
  const realmRoles: string[] = tokenParsed.realm_access?.roles ?? tokenParsed.roles ?? [];
  return {
    id: tokenParsed.sub,
    login: tokenParsed.email,
    firstName: tokenParsed.given_name,
    lastName: tokenParsed.family_name,
    email: tokenParsed.email,
    imageUrl: null,
    activated: true,
    langKey: tokenParsed.locale,
    createdBy: null,
    createdDate: null,
    lastModifiedBy: null,
    lastModifiedDate: null,
    authorities: realmRoles.filter((role: string) => role.startsWith('ROLE_')),
  };
};
